import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function graphFetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATISTIC_GRAPH_FETCHING:
      return true;
    case actions.SET_STATISTIC_GRAPH:
    case actions.SET_STATISTIC_ERROR:
      return false;
    default:
      return state;
  }
}
